module.exports = __webpack_public_path__ + "static/media/pay_driver.d48669c9.svg";